import { bl_svc_issue_worklog_RowClass } from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";

export class SvcIssueWorklogContainerModel extends BaseContainerModel {
    bl_svc_issue_worklog: bl_svc_issue_worklog_RowClass = new bl_svc_issue_worklog_RowClass();
}